import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { authApi } from '../api';

const MemberAuthContext = createContext(null);

export function MemberAuthProvider({ children }) {
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await authApi.verify();
      setMember(res.data.member);
    } catch {
      setMember(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const res = await authApi.login(email, password);
    setMember(res.data.member);
    return res.data.member;
  };

  const register = async (data) => {
    const res = await authApi.register(data);
    setMember(res.data.member);
    return res.data.member;
  };

  const logout = async () => {
    try { await authApi.logout(); } catch { /* ignore */ }
    setMember(null);
  };

  return (
    <MemberAuthContext.Provider value={{ member, loading, login, register, logout, refresh }}>
      {children}
    </MemberAuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(MemberAuthContext);
  if (!ctx) throw new Error('useAuth musí být uvnitř MemberAuthProvider');
  return ctx;
}

// Lidsky čitelné názvy rolí
export const ROLE_LABELS = {
  superadmin: 'Správce systému',
  ops: 'Operační středisko',
  chapter_rep: 'Zástupce spolku',
  member: 'Člen',
};
